import { useQuery } from 'react-query';
import { getAuth } from '@firebase/auth';

const { REACT_APP_API_URL: API_URL } = process.env;

const fetchPhotos = async (type, orderId) => {
  const token = await getAuth().currentUser.getIdToken();

  const res = await fetch(`${API_URL}/photos/${type}/${orderId}`, {
    headers: { authorization: `Bearer ${token}` },
  });
  const data = await res.json();

  if (data.error) throw new Error(`[fetchPhotos]: ${data.error}`);

  return data;
};

export const useFetchPhotos = (type, orderId, options = {}) => {
  return useQuery(['photos', type, orderId], () => fetchPhotos(type, orderId), {
    staleTime: 5 * 60 * 1000,
    retry: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    ...options,
  });
};
